import { render, staticRenderFns } from "./PromotedBuyBox.vue?vue&type=template&id=1c572837&scoped=true"
import script from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedBuyBox.vue?vue&type=style&index=0&id=1c572837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c572837",
  null
  
)

export default component.exports